import { render } from "./password-panel.vue?vue&type=template&id=5f12c818"
import script from "./password-panel.vue?vue&type=script&lang=js"
export * from "./password-panel.vue?vue&type=script&lang=js"

import "./password-panel.vue?vue&type=style&index=0&id=5f12c818&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__